<template>
  <div class="body-1 panel-right" v-if="show" >
  <v-expansion-panels light class="ml-6 mr-5 mb-3 mt-3 caption" 
  v-model="panel">

    <v-expansion-panel
      accordion
      flat
    >
      <v-expansion-panel-header><span class="opensansregular size9">LEGEND</span></v-expansion-panel-header>
      <v-expansion-panel-content v-if="showLegenda">
        <div class="opensansbold size11 text-left mb-2"> {{indicatorTitle}} </div>
        <div class="opensansregular size9 text-left text-lowercase mb-2"> ({{ indicatorUnit }}) </div>
          <!--
          {{$store.getters.legendThresholds}}
          {{thrsNEW}}
          -->
        <v-btn block small class="orange lighten-4 opensansregular mb-3" v-if="showModThrs" @click="resetLegendaColors">
          Reset colors
        </v-btn>
        <v-btn block small class="green lighten-4 opensansregular mb-5" v-if="showModThrs" @click="applyThrColors">
          Apply new thresholds/colors
        </v-btn>
        <!--
        {{thrs}}
        {{thrsNEW}}
        -->
        <div v-if="!showModThrs" @click="showThrControls" :style="'background:' + $store.getters.legendColors[9] +';'" class="color_indicator">
        </div>
        <div class="legend_descriptor opensanslight size8 cursorhand" @click="showThrControls" > 
          Not available
        </div>


        <div v-if="legendType=='single'">
        <div v-for="(col, index) in thrsNEW" class="legend_block" :key="col" >
          <div :style="'background:' + $store.getters.legendColors[index] +';'" class="">
            <span><pick-legend-color :col="$store.getters.legendColors[index]" :index="index"/></span>
          </div>
          <div class="legend_descriptor opensanslight size8"> 
          {{thresholdsLabels[index]}}
          </div>
        </div>
        </div>

        <div v-if="legendType!=='single'">
        <div v-for="(col, index) in thrsNEW" class="legend_block" :key="col" >
          <div v-if="(index < (lenThresholds - 1) || index === 9) && !showModThrs" @click="showThrControls" :style="'background:' + $store.getters.legendColors[index] +';'" class="cursorhand color_indicator">
          </div>
          <!--
          <div v-if="index < 5  && showModThrs" :style="'background:' + col +';'" class="">
            <pick-legend-color :col="col" :index="index"/>
          </div>
          -->
          <div class="legend_descriptor opensanslight size8 cursorhand" @click="showThrControls" v-if="index < (lenThresholds - 2)"> 
            <!-- {{fNum($store.getters.legendThresholds[index])}} - {{fNum($store.getters.legendThresholds[index+1])}} -->
            <span>{{fNum(thrsNEW[index])}} - </span> 
            <span>{{fNum(thrsNEW[index+1])}}</span>
            <!--
            <span v-if="index < 5  && showModThrs" :style="'background:' + col +';'" class="">
              <v-text-field
                class="opensanslight size8"
                v-model="thrsNEW[index+1]"
              ></v-text-field>
            </span>
            -->
          </div>
          <div class="legend_descriptor opensanslight size8" v-if="index == (lenThresholds - 2)"> 
            > {{fNum(thrsNEW[index])}}
          </div>
          <div>
          
          <br>
          <div v-if="index < (lenThresholds - 1)  && showModThrs" :style="'background:' + $store.getters.legendColors[index] +';'" class="">
            <span><pick-legend-color :col="$store.getters.legendColors[index]" :index="index"/></span>
          </div>
          <div>
            <!--
            <v-text-field v-if="index < 4 && index >= 0 && showModThrs" v-model="thrsNEW[index+1]">
            </v-text-field>
            -->
            <div v-if="index < (lenThresholds - 2) && index >= 0 && showModThrs">
              <v-text-field
                label="Change threshold value"
                class="opensanslight size8"
                v-model="thrsNEW[index+1]"
              ></v-text-field>
            </div>
            <!--
            <v-slider v-if="index < 4 && index >= 0 && showModThrs"
              v-model="thrsNEW[index+1]"
              append-icon="mdi-plus"
              prepend-icon="mdi-minus"
              @click:append="zoomIn(index+1)"
              @click:prepend="zoomOut(index+1)"
              :min="thrs[index]"
              :max="thrs[5]"
            ></v-slider>
            -->
          <!--
          <v-slider v-if="index === 4 "
            v-model="thrsNEW[index+1]"
              :min="thrsNEW[index]"
              :max="thrs[index+2]"
          ></v-slider>
          -->
          </div>
          </div>
        </div>

        </div>

        



        <!-- {{$store.getters.indicatorsForCode}} -->

        <!--
        <v-img class="ml-12 mt-3" v-if="show" src="../assets/img/legend.jpg" width=200px> </v-img>
        -->
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!--
    <v-expansion-panel
        accordion
        flat
    >
      <v-expansion-panel-header><span class="opensansregular size9">INDICATOR INFO</span></v-expansion-panel-header>
      <v-expansion-panel-content>
        {{info}}
      </v-expansion-panel-content>
    </v-expansion-panel>
    -->

    <v-expansion-panel
      accordion
      flat
    >
      <v-expansion-panel-header v-if="this.$store.getters.country !== ''" class="opensansregular size9 ucase">{{this.$store.getters.country}}</v-expansion-panel-header>
      <v-expansion-panel-content v-if="this.$store.getters.country !== ''" >
        <!--
        <v-img v-if="show" src="../assets/img/info_country.jpg" contain aspect-ratio="1.5"> </v-img>
        {{this.$store.getters.country}}
        {{this.$store.getters.countryID}}
        -->
        <div class="ml-12 mr-12 mt-0 mb-0 flag">
          <v-img :src="'/flags/' + this.$store.getters.countryID.toLowerCase() +'.svg'"/>
        </div>
        <div class="countryInfo opensansregular size9">
          <ul>
            <li>{{population}} inhabitants</li>
            <li v-if="this.$store.getters.countryElements[this.$store.getters.countryID].TL2">{{this.$store.getters.countryElements[this.$store.getters.countryID].TL2}} large regions (TL2)</li>
            <li v-if="this.$store.getters.countryElements[this.$store.getters.countryID].TL3">{{this.$store.getters.countryElements[this.$store.getters.countryID].TL3}} small regions (TL3)</li>
            <li v-if="this.$store.getters.countryElements[this.$store.getters.countryID].FUA">{{this.$store.getters.countryElements[this.$store.getters.countryID].FUA}} metropolitan areas</li>
            <!-- <li>{{this.$store.getters.countryElements[this.$store.getters.countryID].EFUA}} cities</li> -->
          </ul>
        </div>
        <v-btn color="primary mt-5 mb-3" small dark  @click="resetCountry()">
            <v-icon>clear</v-icon> Reset country
        </v-btn>

      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panels class="" v-if="false">
      <v-expansion-panel
        accordion
        flat
      >
        <v-expansion-panel-header class="opensansregular text-left size9 ucase">Statistic Info</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="opensansbold size11 text-left mb-2"> World </div>
          <div class="opensansregular size9 mb-2"> {Where are data?...} </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>  


    <v-expansion-panels class="">
      <v-expansion-panel
        accordion
        flat
      >
        <v-expansion-panel-header class="opensansregular text-left size9 ucase">Download</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="divaffiancate mr-4">
            <DataTable :indicatorSelObj="indicatorSelObj"/>
          </div>
          <div v-if="!(this.$route.name == 'SubAreaChart' || this.$route.name == 'OECDRegions')" class="divaffiancate  mr-4">
            <v-img src="../assets/img/JPG-icon.png"  @click="map2Pdf()" width="20px" class="cursorhand"> </v-img>
            PDF
          </div>
          <div v-if="!(this.$route.name == 'SubAreaChart' || this.$route.name == 'OECDRegions')" class="divaffiancate">
            <v-img src="../assets/img/JPG-icon.png"  @click="map2Jpg()" width="20px" class="cursorhand"> </v-img>
            JPG
          </div>          
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>  

    <!--v-expansion-panels class="">
      <v-expansion-panel
        accordion
        flat
      >
        <v-expansion-panel-header class="opensansregular text-left size9 ucase">Share</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-img src="../assets/img/Share-icon.png" width="20px" class=""> </v-img>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels-->  


  </v-expansion-panels>   
   <div class="opensansregular text-right size9">
     <v-row class="ml-4 mr-3">
       <v-col md="10" >
<!--    <span class="opensansregularcase size7">{{shareUrl}}</span> -->
        <facebook v-if="true" :url="shareLinkSocial" scale="2" class="ml-2 share cursorhand"></facebook>
        <twitter v-if="true" :url="shareLinkSocial" title="" scale="2" class="ml-2 share cursorhand"></twitter>
        <linkedin v-if="true" :url="shareLinkSocial" scale="2"  class="ml-2 share cursorhand"></linkedin>
        <email v-if="true" :url="shareLinkSocial" title="" scale="2" class="ml-2 share cursorhand"></email>
       </v-col>
      <v-col  md="2">
       <v-img src="../assets/img/Share-icon.png" @click="shareLink" width="20px" class="share cursorhand"> </v-img>
       Share
       </v-col>

     </v-row>
     <span>
     </span>
    <!--
    <telegram :url="shareUrll" scale="2" class="ml-2"></telegram>
    <whats-app :url="shareUrl" title="" scale="2" class="ml-2"></whats-app>
    -->
    <!-- 
    <pinterest :url="url" scale="3"></pinterest>
    <reddit :url="url" scale="3" title="My Github"></reddit>
    -->
    <!-- <VueSocialSharing/> -->
  </div>


    <v-snackbar
      v-model="alert"
      color="purple accent-2"
    >
      {{ alertMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <!--
   <v-alert
      v-model="alert"
      border="left"
      close-text="Close Alert"
      color="purple accent-2"
      dark
      dismissible
      class="opensansregular text-left size7"
      v-html="alertMessage"
    >
    close
    </v-alert>
    -->
  </div>
</template>

<script>

import { formatNumber } from '../utils/misc'
import { numberWithCommas } from '../utils/misc'
import DataTable from "./DataTable.vue"
import PickLegendColor from "./PickLegendColor.vue"

// import Clipboard from 'v-clipboard'
import {
  Facebook,
  Twitter,
  Linkedin,
  // Pinterest,
  // Reddit,
  // Telegram,
  // WhatsApp,
  Email
} from "vue-socialmedia-share"

  export default {
    name: 'PanelSection',
    
    components: {
      Facebook,
      Twitter,
      Linkedin,
      // Telegram,
      // WhatsApp,
      Email,
      DataTable,
      PickLegendColor
    },    
    computed: {
      prefix() {
        if (this.$store.getters.TL === 'TL2' || this.$store.getters.TL === 'TL3' ) {
          return 'REG'
        } else {
          return this.$store.getters.TL
        }
      },
      shareLinkSocial() {
        return(this.getShareUrl())
      }
    },
     watch: {
      '$route' (to) {
        // this.show = to.name.indexOf('MetroRegional') !== 0
        this.name = to.name.indexOf
        this.info = this.$store.getters.indicator
        /*
        let ds = this.$store.getters.population
        let value = ds.Data({REG_ID: this.$store.getters.countryID}).value
        //console.log(numberWithCommas(value))
        */
        let value = parseInt(this.$store.getters.countryInfo.pop)
        this.population = numberWithCommas(value)
        // this.shareLink()
      },
      '$store.getters.legendThresholds': function () {
        this.calcThresholds()
      },
      '$store.getters.movemap': function () {
        // this.shareLink()
      },
      '$store.getters.indicatorsForCode': function () {
        this.setTitleUnit()
        this.panel = 0
      },
      '$store.getters.indicator': function() {
        this.setTitleUnit()
        this.panel = 0
      },      
    },
    methods: {
      zoomIn(i) {
        let step = (this.thrsNEW[5] - this.thrsNEW[0]) / 1000
        this.thrsNEW[i] = (this.thrsNEW[i] + step)
        this.$forceUpdate()
      },
      zoomOut(i) {
        let step = (this.thrsNEW[5] - this.thrsNEW[0]) / 1000
        this.thrsNEW[i] = (this.thrsNEW[i] - step)
        this.$forceUpdate()
      },
      resetLegendaColors () {
        this.$store.dispatch('setLegendColors', this.$store.getters.legendColorsDefault)
        this.$root.$emit('component_refresh')
        this.showModThrs = false
        this.$forceUpdate()
      },
      calcThresholds() {
        console.log(this.$store.getters.all.ds.legendType)
        console.log(this.$store.getters.all.ds.thresholds)
        console.log(this.$store.getters.all.ds.thresholdsLabels)
        this.legendType = this.$store.getters.all.ds.legendType
        this.thresholdsLabels = this.$store.getters.all.ds.thresholdsLabels
        let arr = []
        this.thrsNEW = []
        for (let s of this.$store.getters.legendThresholds) {
          arr.push(s)
          this.thrsNEW.push(s)
        }
        this.thrs = arr
        this.lenThresholds = arr.length
      },
      showThrControls() {
        this.calcThresholds()
        this.showModThrs = true
      },
      applyThrColors () {
        this.$store.commit('setLegendThresholds', this.thrsNEW)
        this.$root.$emit('component_refresh')
        this.showModThrs = false
        this.$forceUpdate()
      },
      getShareUrl() {
        let name = this.$route.name
        let querystring = ''
        if (name === 'Home') {
          try {
            if (this.$store.getters.movemap.h_m1) {
              querystring = querystring + '?m=h_m1&rect=' + this.$store.getters.movemap.h_m1.toString()
            }            
          } catch (error) {
            console.log(error)
          }
        }
        if (name === 'MetroRegional') {
          try {
            if (this.$store.getters.movemap.metroreg_m1) {
              querystring = querystring + '?m=metroreg_m1&rect=' + this.$store.getters.movemap.h_m1.toString()
            }            
          } catch (error) {
            console.log(error)
          }
        }
        if (name === 'SubArea') {
          try {
            if (this.$store.getters.movemap.subarea_m1) {
              querystring = querystring + '?m=subarea_m1&rect=' + this.$store.getters.movemap.subarea_m1.toString()
            }            
          } catch (error) {
            console.log(error)
          }
        }

        return(window.location.href + querystring)

      },
      shareLink: function () {
        this.shareUrl = this.getShareUrl()
        const el = document.createElement('textarea')
        el.value = this.shareUrl
        document.body.appendChild(el)
        el.select()
        document.execCommand("copy")
        document.body.removeChild(el)
        this.alertMessage = "Copied url in clipoard. Use paste or CTRL-V to use it"
        this.alert = true
        // this.$clipboard(this.shareUrl)
      },
      goDataTable: function () {
        let params = this.$route.params
        this.$router.push({ name: 'DataTable', params: params })
      },
      setTitleUnit: function () {
        try {

          this.indicatorSelObj = this.$store.getters.indicatorsForCode[ this.prefix + '-' + this.$store.getters.indicator]
          this.indicatorTitle = this.$store.getters.indicatorsForCode[ this.prefix + '-' + this.$store.getters.indicator].Theme
          this.indicatorUnit = this.$store.getters.indicatorsForCode[this.prefix + '-' + this.$store.getters.indicator].Unit
          this.$store.commit('setIndicatorTitle', this.indicatorTitle)
          this.$store.commit('setIndicatorUnit', this.indicatorUnit)
          this.showLegenda = true
          this.$forceUpdate()          
        } catch (error) {
          // console.log(error)
        }
      },
      map2Pdf: function() {
        this.$root.$emit('map_2_pdf')
      },
      map2Jpg: function() {
        this.$root.$emit('map_2_jpg')
      },      
      fNum: function (n) {
        return formatNumber(n)
      },
      resetCountry: function () {
        let params = this.$route.params
        params.c = 'x'
        params.tu = 'x'
        this.$router.push({ name: 'Home', params: params })
      },      
    },
    data () {
      let show = true
      let name = ''
      let info = ''
      let legend_color = true
      let population = 0
      let legendType = ''
      let legendLabels = []
      let thrs = []
      let thrsNEW = []
      let showModThrs = false
      let lenThresholds = 0
        return {
          population,
          show,
          name,
          info,
          panel: 0,
          showLegenda: false,
          indicatorTitle: '',
          indicatorUnit: '',
          indicatorSelObj: null,
          shareUrl: '',
          alertMessage: '',
          alert: false,
          legend_color,
          legendType,
          legendLabels,
          thrs,
          thrsNEW,
          showModThrs,
          lenThresholds,
          timeout: 2000
        }    
    },
    mounted () {
    }
  }
</script>

<style>

.color_indicator {
  height: 15px;
  width: 15px;
  border: dimgray;
  border-width: 1px;
  border-style: solid;
  float:left; display:block;
  margin-bottom: 5px;
  margin-right: 5px;
  padding: 0px;
}

.countryInfo {
  width: 90%;
  margin-top: 10px;
  text-align: left;
}

.share {
  margin-left:auto; margin-right:0;
}

.flag0 {
  border: rgb(202, 199, 199);
  border-width: 1px;
  border-style: solid;
}

.flag {
  padding: 10px;
  background: rgb(246, 244, 244);
}
.legend_block {
  clear: both;
}

.legend_descriptor {
  float:left; 
  display:block;
  height: 18px;
  line-height: 18px;
}


.v-img{
  cursor:grabbing;
  height:42px;
  width:42px;
}
</style>